import { createSelector } from 'reselect'

const getData = state => state.home.data

export const getTotalSum = createSelector(
  [ getData ],
  (data = {}) => {
    return Object.values(data).reduce((result, item) => {
      item.map(el => {
        if (!result[el._id]) result[el._id] = 0
        result[el._id] = result[el._id] + el.sum
        return true
      })
      return result
    }, {})
  }
)



// WEBPACK FOOTER //
// ./src/selectors/home.js